exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[target=_blank][data-v-28d82aaa]:after{font-family:FontAwesome;content:\" \\F08E\"}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-28d82aaa]{font-size:1.6em}.booking-information[data-v-28d82aaa]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28d82aaa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/serviceonboard/Home.vue
// module id = 590
// module chunks = 0